<template>
  <div>
    <el-select :value="selected" @input="dispatch" :placeholder="placeholder || $t('message.language')" filterable clearable :multiple="multiple"
      :size="size" class="d-block">
      <el-option v-for="(language,index) in languages" :key="'languages-' + index" :label="language.name" :value="language.id"></el-option>
    </el-select>
  </div>
</template>
<script>
  import {mapGetters, mapActions} from "vuex";
  import { i18n  } from '@/utils/i18n';
  export default {
    props: {
        size: {
            default: 'small'
        },
        placeholder: {
            default: null,
        },
       id:{
          default: null
        },
         multiple:{
            type: Boolean,
            default: false,
        }
    },
     watch:{
      id:{
        handler: function() {
            this.selected = this.id
        },
        immediate: true
      }
    },
    data() {
      return {
        selected: null,
      }
    },
    mounted() {
      if (this.languages && this.languages.length === 0) this.updateInventory()
    },
    computed: {
      ...mapGetters({
        languages: 'language/inventory'
      })
    },
    methods: {
      ...mapActions({
        updateInventory: 'language/inventory'
      }),
      dispatch(e) {
        this.$emit('input', e)
        this.selected = e
      }
    },
  }

</script>
